export default function isDef(value) {
  return (typeof value !== 'undefined')
}
